import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Clock, Timer, Loader2, Pencil } from "lucide-react";

export default function EditGameDialog({ open, onOpenChange, editGame, setEditGame, handleSaveEdit, isSaving, calcMondayDeadline, t }) {
  if (!editGame) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border">
        <DialogHeader>
          <DialogTitle>{t("gameRegistrations.editGameTitle")}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Titulo</Label>
            <Input
              value={editGame.title}
              onChange={(e) => setEditGame({ ...editGame, title: e.target.value })}
              data-testid="edit-game-title"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Data</Label>
              <Input
                type="date"
                value={editGame.date}
                onChange={(e) => {
                  const newDate = e.target.value;
                  setEditGame({ ...editGame, date: newDate, guest_deadline: calcMondayDeadline(newDate) });
                }}
              />
            </div>
            <div className="space-y-2">
              <Label>Horario</Label>
              <Input
                type="time"
                value={editGame.time}
                onChange={(e) => setEditGame({ ...editGame, time: e.target.value })}
              />
            </div>
          </div>
          <div className="space-y-2">
            <Label>Local</Label>
            <Input
              value={editGame.location}
              onChange={(e) => setEditGame({ ...editGame, location: e.target.value })}
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Maximo de Jogadores</Label>
              <Input
                type="number"
                value={editGame.max_players}
                onChange={(e) => setEditGame({ ...editGame, max_players: parseInt(e.target.value) || 18 })}
                min={1}
                max={50}
              />
            </div>
            <div className="space-y-2">
              <Label className="flex items-center gap-1">
                <Timer className="h-3.5 w-3.5" />
                Prazo Convidados (auto: Seg 12:01)
              </Label>
              <Input
                type="datetime-local"
                value={editGame.guest_deadline}
                onChange={(e) => setEditGame({ ...editGame, guest_deadline: e.target.value })}
              />
            </div>
          </div>
          {/* Agendar abertura */}
          <div className="space-y-2 p-3 rounded-lg bg-muted/30 border border-border/50">
            <Label className="flex items-center gap-1.5 text-sm font-medium">
              <Clock className="h-3.5 w-3.5 text-primary" />
              Agendar abertura das inscricoes
            </Label>
            <Input
              type="datetime-local"
              value={editGame.scheduled_open}
              onChange={(e) => setEditGame({ ...editGame, scheduled_open: e.target.value })}
              data-testid="edit-scheduled-open-input"
            />
            <p className="text-[11px] text-muted-foreground">
              {editGame.scheduled_open
                ? "Inscricoes abrirao automaticamente nesta data/hora. Push enviado aos jogadores."
                : "Sem agendamento. Controle manualmente com o botao Abrir/Fechar."}
            </p>
          </div>
          <Button onClick={handleSaveEdit} disabled={isSaving} className="w-full" data-testid="save-edit-game-btn">
            {isSaving ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Pencil className="h-4 w-4 mr-2" />}
            Salvar Alteracoes
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
